import React, { useEffect, useRef, useState } from 'react';

/**
 * High5RmDagilimi: High5 Google + Meta harcamasının yeni kullanıcı / remarketing
 * ayrımı — kampanya, reklam grubu/seti ve PMax varlık grubu adlarındaki RM / NU /
 * INTEREST işaretlerine göre. Akış diyagramı + iki sütunlu kampanya listesi.
 * Route: /r/high5-rm-dagilimi (ProtectedRoute allowBrandIds High5, sidebar'da VAR)
 *
 * İçerik statik (28 Eyl 2026'ya kadar). Yeniden üretmek için:
 *   node src/pages/high5-rm-dagilimi/build.js
 */
export default function High5RmDagilimi() {
  const [html, setHtml] = useState(null);
  const [height, setHeight] = useState(720);
  const boxRef = useRef(null);

  useEffect(() => {
    let alive = true;
    import('./high5RmDagilimiHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  // iframe'i içerik alanının kalan yüksekliğine oturt. Rapor kendi içinde kayar,
  // sayfa gövdesi kaymaz — iki kaydırma çubuğu üst üste binmesin.
  useEffect(() => {
    const fit = () => {
      const top = boxRef.current?.getBoundingClientRect().top ?? 0;
      setHeight(Math.max(480, window.innerHeight - top - 16));
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [html]);

  return (
    <div ref={boxRef} className="px-2 pb-2">
      {html ? (
        <iframe
          title="High5 · Yeni kullanıcı / Remarketing"
          srcDoc={html}
          style={{
            width: '100%',
            height,
            border: '1px solid #e5e7eb',
            borderRadius: 12,
            display: 'block',
            background: '#F6F8FF',
          }}
        />
      ) : (
        <div
          style={{ height, borderRadius: 12, background: '#F6F8FF' }}
          aria-busy="true"
        />
      )}
    </div>
  );
}
